import TransactionDetails from 'features/accounts/TransactionDetails/TransactionDetails';
import React from 'react';

export default function Page() {
  return <TransactionDetails />;
}
